import React, { useState } from 'react'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../components/Modal/modal'
import ListKeyWords from '../../components/ListKeyWords/ListKeyWords';
import './AddKeyWord.css'
import { Grid, Button, TextField } from '@mui/material';
import axios from "axios"
import { URL } from '../../constants/constant';

const AddKeyWord = ({selectedRows, setOpen, setMessage, newKeyWord, setNewKeyWord, keyWords, setKeyWords, getTableData}) => {
    const [showModal, setShowModal] = useState(false);

    const modalButtonClick = () => {
        if (selectedRows.length <= 0) {
            setOpen(true)
            setMessage('Please select a Package first')
            return
        }
        setShowModal(true)
    }

    const closeModal = () => {
        setKeyWords([])
        setNewKeyWord('')
        setShowModal(false)
    }

    const addKeyWord = () => {
        if (newKeyWord.includes(',')) {
            setOpen(true)
            setMessage('Keyword cannot contain comma (,)')
            return
        }
        
        if (keyWords.indexOf(newKeyWord) !== -1){
            setOpen(true)
            setMessage('Keyword is already added')
            return
        }

        if (newKeyWord === '') {
            setOpen(true)
            setMessage('Please enter some text before adding')
            return
        }

        let listKeyWords = selectedRows[0].keywords
        listKeyWords = listKeyWords.split(', ')
        if (listKeyWords.indexOf(newKeyWord) !== -1) {
            setOpen(true)
            setMessage('Keyword is already present in the knowledge base')
            return
        }

        setKeyWords([...keyWords,newKeyWord.trim()])
        setNewKeyWord('')
    }

    const removeKeyWord = (keyName) => {
        setKeyWords(keyWords.filter((key) => key !== keyName));
    }

    const addKeyWordAPI = () => {
        if (keyWords.length === 0) {
            setOpen(true)
            setMessage('Please add a keyword first before saving')
            return
        }

        const keyWordsConcat = keyWords.join(',')

        const user = JSON.parse(localStorage.getItem("loggedInUserDetails")).emailId;

        const data = JSON.stringify({
            "subtest_name" : selectedRows[0].subtest_name,
            "newKeywords": keyWordsConcat,
            "user": user
        });
        
        var config = {
            method: 'post',
            url: URL.demystify_url + 'knowledgeBase/addKeywords',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
        };

        axios(config)
        .then(function (response) {
            if(response.data.success === 1) {
                setOpen(true); 
                setMessage("Keywords added succesfully"); 
                getTableData();
            }
            else if(response.data.success === 0){
                setOpen(false); 
                setMessage(response.data.errorMessage);
            }
        })
        .catch(function (error) {
            alert("Something went wrong, please try again")
            console.log(error);
        });
        
        closeModal()
    }

    return (
        <Grid>
            <div className='add-keyword'>
                    <Button variant='contained' onClick={modalButtonClick}>
                        Add Key Words
                    </Button>
                </div>

                <div>
                    <Modal show={showModal} setShow={setShowModal}>
                        <ModalHeader className='modal-header'>
                            <h2>Add Key Words</h2>
                        </ModalHeader>
                        <ModalBody>
                            <div className='subtest-name' >
                                <div className='new-key-word' style={{justifyContent:'center'}}>
                                    <h3 style={{textAlign:'center',fontWeight:'bold'}}>Sub Test Name :<span>{selectedRows.length>0 ? selectedRows[0].subtest_name:undefined}</span></h3>
                                </div>
                            </div>
                            <div className='new-key-word'>
                                <TextField
                                    rows={1}
                                    autoComplete='off'
                                    value={newKeyWord}
                                    onChange={ (e) => {
                                        setNewKeyWord(e.target.value);
                                    }}
                                    variant='outlined'
                                    label = 'Key Word' 
                                    style={{width:300}}
                                    className='new-key-word'
                                    InputProps={{endAdornment: <Button variant='contained' onClick={addKeyWord} type="submit">Add</Button>}}
                                />
                            </div>
                            <ListKeyWords keyWords={keyWords} removeTest={removeKeyWord}/>
                        </ModalBody>

                        <ModalFooter>
                            <Button variant="contained" style={{marginRight: 50}} onClick={addKeyWordAPI}>Save</Button>
                            <Button onClick={closeModal} variant="outlined">
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
        </Grid>
    )
}

export default AddKeyWord